/*
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export const commonWarnings = [
  [
    'JSON_VALIDATION_IN_DEBUG_VIEW',
    "This ping did not pass validation during ingestion (this is normal if you're using custom developer build), but was correctly validated against Glean schema in Debug Viewer."
  ]
];
